module.exports = __webpack_public_path__ + "img/gzhsuncode.a2ddceed.jpg";